import { ValueObject } from '@nx-smartmonkey/shared/domain';
import { Subscription } from '../subscription/Subscription';
import { ProjectResources } from './ProjectResources';

export interface OrganizationResourcesProps {
  organization_id: string;
  subscription: Subscription;
  projects: ProjectResources[];
  users: number;
}

export class OrganizationResources extends ValueObject<OrganizationResourcesProps> {
  get organization_id(): string {
    return this.props.organization_id;
  }

  get subscription(): Subscription {
    return this.props.subscription;
  }

  get projects(): ProjectResources[] {
    return this.props.projects;
  }

  private constructor(props: OrganizationResourcesProps) {
    super(props);
  }

  static create(props: OrganizationResourcesProps): OrganizationResources {
    return new OrganizationResources(props);
  }

  getProjectResources(projectId: string): ProjectResources | undefined {
    return this.props.projects.find((project) => project.project_id === projectId);
  }

  getVehicleCount(): number {
    return this.props.projects.reduce((acc, project) => acc + project.getVehicleCount(), 0);
  }

  getSupervisorsCount(): number {
    return this.props.projects.reduce((acc, project) => acc + project.supervisors, 0);
  }

  getProjectsCount(): number {
    if (this.subscription.plan === `monkey`) {
      return 1;
    }

    return this.props.projects.length;
  }

  getUsersCount(): number {
    if (this.subscription.plan === `monkey`) {
      return 1;
    }
    return this.props.users;
  }

  exceedsVehicleHardLimit(newVehicles = 0): boolean {
    return this.subscription.has_contract && this.subscription.vehicles < this.getVehicleCount() + newVehicles;
  }

  exceedsSupervisorsHardLimit(newSupervisores = 0): boolean {
    return (
      this.subscription.has_contract && this.subscription.supervisors < this.getSupervisorsCount() + newSupervisores
    );
  }

  exceedsProjectsHardLimit(newProjects = 0): boolean {
    return this.subscription.has_contract && this.subscription.projects < this.getProjectsCount() + newProjects;
  }

  exceedsUsersHardLimit(newUsers = 0): boolean {
    return this.subscription.has_contract && this.subscription.users < this.getUsersCount() + newUsers;
  }
}
